export default class Header {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		

		if(!this.isset('id')) {
			this.item.id = false;
		}

		if(!this.isset('paddingTop')) {
			this.item.paddingTop = '20px';
		}

		if(!this.isset('left_text')) {
			this.item.left_text = '';
		}

		if(!this.isset('left_font')) {
			this.item.left_font = 'inherit';
		}

		if(!this.isset('left_color')) {
			this.item.left_color = 'inherit';
		}

		if(!this.isset('left_size')) {
			this.item.left_size = 'inherit';
		}


		if(!this.isset('right_text')) {
			this.item.right_text = 'Having trouble reading this email?';
		}

		if(!this.isset('right_font')) {
			this.item.right_font = 'inherit';
		}

		if(!this.isset('right_color')) {
			this.item.right_color = 'inherit';
		}

		if(!this.isset('right_size')) {
			this.item.right_size = 'inherit';
		}

	}
}


// WEBPACK FOOTER //
// ./helpers/header.js